/** Ethena-style cooldown surface (sUSDe). After `cooldownShares` /
 *  `cooldownAssets`, the staked balance is escrowed and `cooldowns(user)`
 *  returns when it unlocks plus the underlying amount owed. When
 *  `cooldownDuration()` is 0 the vault behaves as a vanilla ERC-4626
 *  (instant `withdraw`/`redeem`) and `cooldowns` stays empty.
 *
 *  Verified getter (EIP-aside, protocol-specific):
 *    `cooldowns(address) → (uint104 cooldownEnd, uint152 underlyingAmount)` */
export const EthenaCooldownAbi = [
  {
    name: 'cooldowns',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: 'owner' }],
    outputs: [
      { type: 'uint104', name: 'cooldownEnd' },
      { type: 'uint152', name: 'underlyingAmount' },
    ],
  },
] as const
